import React from 'react';
import FlowEditor from './FlowEditor';

export default function EditFlow(props) {
    return <FlowEditor {...props} mode="edit"/>;
}
